import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import Loader from "../../../Loader/Loader";
import {
    errorToastMessage,
    successToastMessage,
} from "../../../../utils/toastMessage";

const RateModel = ({ closeModal, data, para }) => {
    
    const [listData, setListData] = useState([]); // hierarchical data

    const [value, setValue] = useState({
        dayname: "",
        dynamicratejumpid: "",
        value: "",
    });

    const [loading, setLoading] = useState(false);
    const [levelData, setLevelData] = useState(0);

    const GetLevelName = (slab) => {
        switch (slab) {
            case "0-5%":
            case "6-10%":
                return 0;
            case "11-15%":
            case "16-20%":
                return 1;
            case "21-25%":
            case "26-30%":
                return 2;
            case "31-35%":
            case "36-40%":
                return 3;
            case "41-45%":
            case "46-50%":
                return 4;
            case "51-55%":
            case "56-60%":
                return 5;
            case "61-65%":
            case "66-70%":
                return 6;
            case "71-75%":
            case "76-80%":
                return 7;
            case "81-85%":
            case "86-90%":
                return 8;
            case "91-95%":
            case "96-100%":
                return 9;
            default:
                return 9;
        }
    };
    const getDayName = (dateString) => {
        const date = new Date(dateString + " 00:00:00");
        const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
        return days[date.getDay()];
    };

    const [loadingSave, setloadingSave] = useState(false);
    const handleSave = async () => {
        if (value?.value !== "") {
            setloadingSave(true);
            let Submit = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.RevenueManagement +
                        API_URL.DYNAMIC_RATE_CONFIG.JUMP_SAVE_BY_ID,
                    body: {
                        dayname: value?.dayname,
                        dynamicratejumpid: value?.dynamicratejumpid,
                        value: Number(value?.value),
                        propertyid: para?.propertyDetail?.propertyid,
                    },
                },
                true
            );

            let wd_response = apiResponse(false, Submit);
            if (wd_response?.isValidate) {
                successToastMessage("Data saved successfully");
            } else {
                // setListData([]);
            }
            setloadingSave(false);
        } else {
            errorToastMessage("Please change value first");
        }
    };

    const GetRoomData = async (data, para) => {
        setLoading(true);
        let wd = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.DYNAMIC_RATE_CONFIG.JUMP_LIST_FOR_VIEW,
                body: {
                    date: data?.StayDate,
                    propertycode: para?.propertyCode,
                },
            },
            false
        );

        let wd_response = apiResponse(false, wd);

        if (wd_response?.isValidate) {
            let _D = wd_response?.data?.data.sort((a, b) => b.minlevel - a.minlevel);
            setListData(_D);
            setLoading(false);
        } else {
            setListData([]);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (data) {
            GetRoomData(data, para);
            setLevelData(GetLevelName(data?.occupancy_slab));
        }
    }, [data]);

    return (
        <div
            className={`GroupNameModalMain singleDateSummaryModalMain ToolsSingleTicketPopUpMain`} style={{ height: "370px; !important" }}
        >
            <div className="GroupNameModalHeader">
                <div className="singleDateSummaryModalHeader">
                    <h2>
                        {" "}
                        {`${parseInt(data?.total_roomnights)} Rooms ${parseInt(
                            data?.avg_leadtime
                        )} Days ${commonService.formateAmount(parseInt(data?.avg_rate))}`}
                    </h2>
                </div>
                <button id={commonService.generateGlobalClickTrackerID("RateModel", "button-onclick", data)} className="btn-close" onClick={closeModal}></button>
            </div>
            <div className="singleDateSummaryModalContent">
                <div className="ViewPropertySetupTable">
                    <div className="table__container">
                        <div className="stripped__table">
                            <Table className="table-with-spacing positionStaticTable dailySummaryTbl myTable">
                                <thead className="tbl-header-sticky">
                                    <tr className="table-main-header-tr">
                                        <th className="border_right width75">Level</th>
                                        <th className="border_right text-center width75">SUN</th>
                                        <th className="border_right text-center width75">MON</th>
                                        <th className="border_right text-center width75">TUE</th>
                                        <th className="border_right text-center width75">WED</th>
                                        <th className="border_right text-center width75">THU</th>
                                        <th className="border_right text-center width75">FRI</th>
                                        <th className="border_right text-center width75">SAT</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading ? (
                                        <tr style={{ height: "80px", position: "relative" }}>
                                            <Loader />
                                        </tr>
                                    ) : listData?.length > 0 ? (
                                        listData?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className="border_right width75">{item?.maxlevel}</td>
                                                    <td
                                                        className={`border_right text-center width75 ${getDayName(data?.StayDate) === "sun" &&
                                                            item?.maxlevel === levelData
                                                            ? "bg-success text-white"
                                                            : ""
                                                            }`}
                                                    >
                                                        {getDayName(data?.StayDate) === "sun" &&
                                                            item?.maxlevel === levelData ? (
                                                            <>
                                                                <input id={commonService.generateGlobalClickTrackerID("RateModel", "sun", item)}
                                                                    style={{
                                                                        padding: "0px 6px",
                                                                        borderRadius: "3px !important",
                                                                    }}
                                                                    className={"form-control width75 text-center"}
                                                                    type="text"
                                                                    defaultValue={item?.sun}
                                                                    onChange={(e) => {
                                                                        setValue({
                                                                            dayname: "sun",
                                                                            dynamicratejumpid:
                                                                                item?.dynamicratejumpid,
                                                                            value: e.target.value,
                                                                        });
                                                                    }}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>{commonService.formateAmount(item?.sun)}</>
                                                        )}
                                                    </td>
                                                    <td
                                                        className={`border_right text-center width75 ${getDayName(data?.StayDate) === "mon" &&
                                                            item?.maxlevel === levelData
                                                            ? "bg-success text-white"
                                                            : ""
                                                            }`}
                                                    >
                                                        {getDayName(data?.StayDate) === "mon" &&
                                                            item?.maxlevel === levelData ? (
                                                            <>
                                                                <input id={commonService.generateGlobalClickTrackerID("RateModel", "mon", item)}
                                                                    style={{
                                                                        padding: "0px 6px",
                                                                        borderRadius: "3px !important",
                                                                    }}
                                                                    className={"form-control width75  text-center"}
                                                                    type="text"
                                                                    defaultValue={item?.mon}
                                                                    onChange={(e) => {
                                                                        setValue({
                                                                            dayname: "mon",
                                                                            dynamicratejumpid:
                                                                                item?.dynamicratejumpid,
                                                                            value: e.target.value,
                                                                        });
                                                                    }}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>{commonService.formateAmount(item?.mon)}</>
                                                        )}
                                                    </td>
                                                    <td
                                                        className={`border_right text-center width75 ${getDayName(data?.StayDate) === "tue" &&
                                                            item?.maxlevel === levelData
                                                            ? "bg-success text-white"
                                                            : ""
                                                            }`}
                                                    >
                                                        {getDayName(data?.StayDate) === "tue" &&
                                                            item?.maxlevel === levelData ? (
                                                            <>
                                                                <input id={commonService.generateGlobalClickTrackerID("RateModel", "tue", item)}
                                                                    style={{
                                                                        padding: "0px 6px",
                                                                        borderRadius: "3px !important",
                                                                    }}
                                                                    className={"form-control width75 text-center"}
                                                                    type="text"
                                                                    defaultValue={item?.tue}
                                                                    onChange={(e) => {
                                                                        setValue({
                                                                            dayname: "tue",
                                                                            dynamicratejumpid:
                                                                                item?.dynamicratejumpid,
                                                                            value: e.target.value,
                                                                        });
                                                                    }}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>{commonService.formateAmount(item?.tue)}</>
                                                        )}
                                                    </td>
                                                    <td
                                                        className={`border_right text-center width75 ${getDayName(data?.StayDate) === "wed" &&
                                                            item?.maxlevel === levelData
                                                            ? "bg-success text-white"
                                                            : ""
                                                            }`}
                                                    >
                                                        {getDayName(data?.StayDate) === "wed" &&
                                                            item?.maxlevel === levelData ? (
                                                            <>
                                                                <input id={commonService.generateGlobalClickTrackerID("RateModel", "wed", item)}
                                                                    style={{
                                                                        padding: "0px 6px",
                                                                        borderRadius: "3px !important",
                                                                    }}
                                                                    className={"form-control width75 text-center"}
                                                                    type="text"
                                                                    defaultValue={item?.wed}
                                                                    onChange={(e) => {
                                                                        setValue({
                                                                            dayname: "wed",
                                                                            dynamicratejumpid:
                                                                                item?.dynamicratejumpid,
                                                                            value: e.target.value,
                                                                        });
                                                                    }}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>{commonService.formateAmount(item?.wed)}</>
                                                        )}
                                                        {/* {item?.wed} */}
                                                    </td>
                                                    <td
                                                        className={`border_right text-center width75 ${getDayName(data?.StayDate) === "thu" &&
                                                            item?.maxlevel === levelData
                                                            ? "bg-success text-white"
                                                            : ""
                                                            }`}
                                                    >
                                                        {/* {item?.thu} */}
                                                        {getDayName(data?.StayDate) === "thu" &&
                                                            item?.maxlevel === levelData ? (
                                                            <>
                                                                <input id={commonService.generateGlobalClickTrackerID("RateModel", "thu", item)}
                                                                    style={{
                                                                        padding: "0px 6px",
                                                                        borderRadius: "3px !important",
                                                                    }}
                                                                    className={"form-control width75 text-center"}
                                                                    type="text"
                                                                    defaultValue={item?.thu}
                                                                    onChange={(e) => {
                                                                        setValue({
                                                                            dayname: "thu",
                                                                            dynamicratejumpid:
                                                                                item?.dynamicratejumpid,
                                                                            value: e.target.value,
                                                                        });
                                                                    }}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>{commonService.formateAmount(item?.thu)}</>
                                                        )}
                                                    </td>
                                                    <td
                                                        className={`border_right text-center width75 ${getDayName(data?.StayDate) === "fri" &&
                                                            item?.maxlevel === levelData
                                                            ? "bg-success text-white"
                                                            : ""
                                                            }`}
                                                    >
                                                        {/* {item?.fri} */}
                                                        {getDayName(data?.StayDate) === "fri" &&
                                                            item?.maxlevel === levelData ? (
                                                            <>
                                                                <input id={commonService.generateGlobalClickTrackerID("RateModel", "fri", item)}
                                                                    style={{
                                                                        padding: "0px 6px",
                                                                        borderRadius: "3px !important",
                                                                    }}
                                                                    className={"form-control width75 text-center"}
                                                                    type="text"
                                                                    defaultValue={item?.fri}
                                                                    onChange={(e) => {
                                                                        setValue({
                                                                            dayname: "fri",
                                                                            dynamicratejumpid:
                                                                                item?.dynamicratejumpid,
                                                                            value: e.target.value,
                                                                        });
                                                                    }}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>{commonService.formateAmount(item?.fri)}</>
                                                        )}
                                                    </td>
                                                    <td
                                                        className={`border_right text-center width75 ${getDayName(data?.StayDate) === "sat" &&
                                                            item?.maxlevel === levelData
                                                            ? "bg-success text-white"
                                                            : ""
                                                            }`}
                                                    >
                                                        {/* {item?.sat} */}
                                                        {getDayName(data?.StayDate) === "sat" &&
                                                            item?.maxlevel === levelData ? (
                                                            <>
                                                                <input id={commonService.generateGlobalClickTrackerID("RateModel", "sat", item)}
                                                                    style={{
                                                                        padding: "0px 6px",
                                                                        borderRadius: "3px !important",
                                                                    }}
                                                                    className={"form-control width75 text-center"}
                                                                    type="text"
                                                                    defaultValue={item?.sat}
                                                                    onChange={(e) => {
                                                                        setValue({
                                                                            dayname: "sat",
                                                                            dynamicratejumpid:
                                                                                item?.dynamicratejumpid,
                                                                            value: e.target.value,
                                                                        });
                                                                    }}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>{commonService.formateAmount(item?.sat)}</>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                <div className="text-end">
                    {
                        loadingSave ? <button
                            className="default-btn primary-btn mt-2"
                            type="button"
                            disabled
                        >
                            <span
                                className="spinner-border spinner-border-sm me-3"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Loading...
                        </button> : <Button id={commonService.generateGlobalClickTrackerID("RateModel", "save", data)} className="default-btn primary-btn mt-2" onClick={handleSave}>Save</Button>
                    }

                </div>
            </div>
        </div>
    );
};

export default RateModel;
